/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonNotification,
    JsonNotificationFromJSON,
    JsonNotificationFromJSONTyped,
    JsonNotificationToJSON,
} from './JsonNotification';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonNotification
 */
export interface ApiResultOfListOfJsonNotification {
    /**
     * 
     * @type {Array<JsonNotification>}
     * @memberof ApiResultOfListOfJsonNotification
     */
    data?: Array<JsonNotification>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonNotification
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonNotification
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonNotification
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonNotification
     */
    result?: ApiResultOfListOfJsonNotificationResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonNotificationResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonNotificationFromJSON(json: any): ApiResultOfListOfJsonNotification {
    return ApiResultOfListOfJsonNotificationFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonNotificationFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonNotificationToJSON(value?: ApiResultOfListOfJsonNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonNotificationToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

